export const DarkTheme = {
    colors: {
        primary: 'black',
        secondary: 'midnightblue',
        orange_bar: '#E97C57', //
    },
    body: {
        background: '#252836',
        color: 'white',
    },
    UI: {
        navigation__button: {
            hover: "rgba(234, 234, 234, 0.3)",
        },
        grid_card: {
            background: '#303340',
            border: '1px solid rgba(213, 204, 204, 0.33)',
        },
    },
    about: {
        boxShadow: '0px 0px 20px 5px rgba(167, 134, 197, 0.3)',
    }
}
